export default __webpack_public_path__ + "static/media/le_lion2.1f66b3be.jpg";